<template>
  <div
    class="conversations-list-wrap"
    :class="{
      hide: !showConversationList,
      'list--full-width': isOnExpandedLayout,
    }"
  >
    <div class="chat-list__top">
      <h1 class="page-title text-truncate" :title="pageTitle">
        {{ pageTitle }}
      </h1>
    </div>

    <div class="boards-conversations">
      <call-list/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CallList from './CallList';

export default {
    components: {
      CallList,
    },
    props: {
        conversationInbox: {
            type: [String, Number],
            default: 0,
        },
        teamId: {
            type: [String, Number],
            default: 0,
        },
        label: {
            type: String,
            default: '',
        },
        conversationType: {
            type: String,
            default: '',
        },
        foldersId: {
            type: [String, Number],
            default: 0,
        },
        showConversationList: {
            default: true,
            type: Boolean,
        },
        isOnExpandedLayout: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        ...mapGetters({
            activeInbox: 'getSelectedInbox',
        }),
        inbox() {
            return this.$store.getters['inboxes/getInbox'](this.activeInbox);
        },
        pageTitle() {
            if (this.inbox.name) {
                return this.inbox.name;
            }
            if (this.activeTeam.name) {
                return this.activeTeam.name;
            }
            if (this.label) {
                return `#${this.label}`;
            }
            return this.$t('CALL_PAGE.HEADER');
        },
        activeTeam() {
            if (this.teamId) {
                return this.$store.getters['teams/getTeam'](this.teamId);
            }
            return {};
        },
    },
};
</script>

<style scoped lang="scss">
.page-title {
  margin-top: var(--space-two);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-big);
}
</style>